import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["calendarId", "clearLabel", "max", "maxValidationMessage", "min", "minValidationMessage", "onChange", "today", "todayLabel", "children", "onFocusLeave", "onOpenChange", "open", "calendarPage", "onCalendarPageChange", "value", "disabledValues", "focusedValue", "onMouseDown"];
import { Fragment } from 'react';
import { Popover } from '../Popover';
import { CalendarFooterButtons } from './internal/CalendarFooterButtons';
import { CalendarPage } from './CalendarPage';
import { filterProps } from '../../../utils/filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CalendarPagePopover = _ref => {
  let {
      calendarId,
      clearLabel,
      max,
      maxValidationMessage,
      min,
      minValidationMessage,
      onChange,
      today,
      todayLabel,
      children,
      onFocusLeave,
      onOpenChange,
      open,
      calendarPage,
      onCalendarPageChange,
      value,
      disabledValues,
      focusedValue,
      onMouseDown
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps: _domProps,
    tokenProps
  } = filterProps(rest);
  const domProps = _domProps; // We only accept `DOMProps` via `filterProps` for this component. The `domProps` object is typed more broadly and is causing a TS error with the Popover `target` prop and the `LinkDOMProps` `target` prop.

  return /*#__PURE__*/_jsx(Popover, Object.assign({}, domProps, tokenProps, {
    overflow: "hidden",
    arrowSize: "none",
    content: {
      body: /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(CalendarPage, {
          onMouseDown: onMouseDown,
          value: value,
          id: calendarId,
          max: max,
          maxValidationMessage: maxValidationMessage,
          min: min,
          minValidationMessage: minValidationMessage,
          onChange: onChange,
          today: today,
          calendarPage: calendarPage,
          onCalendarPageChange: onCalendarPageChange,
          disabledValues: disabledValues,
          focusedValue: focusedValue
        }), /*#__PURE__*/_jsx(CalendarFooterButtons, {
          clearLabel: clearLabel,
          max: max,
          maxValidationMessage: maxValidationMessage,
          min: min,
          minValidationMessage: minValidationMessage,
          onChange: onChange,
          today: today,
          todayLabel: todayLabel
        })]
      })
    },
    onOpenChange: onOpenChange,
    placement: "bottom right",
    onFocusLeave: onFocusLeave,
    open: open,
    children: children
  }));
};